import { AlertCircle } from "lucide-react";

import { CustomToolTip } from "../ui/CustomToolTip";

import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { cn } from "@/utils/core/generalUtils";

type FormFieldProps = ReactChildren &
  ClassName & {
    label?: string;
    isRequired?: boolean;
    warning?: boolean;
    warningMessage?: string;
    labelWrapperClassName?: string;
  };

const FormWrapper: React.FC<FormFieldProps> = ({
  label,
  children,
  className,
  isRequired = false,
  warning = false,
  warningMessage,
  labelWrapperClassName,
}) => {
  return (
    <>
      <FormItem className={cn("space-y-2", className)}>
        <div
          className={cn(
            " flex items-center w-[88%] justify-between",
            labelWrapperClassName,
          )}
        >
          {label && (
            <FormLabel className='font-normal flex items-start gap-x-[0.5px] pl-1'>
              {label}
              {isRequired ? (
                <span className='text-red-500  text-xs leading-[8px]'>*</span>
              ) : null}
            </FormLabel>
          )}
          {warning && (
            <CustomToolTip
              toolTipContent={warningMessage || "This field is required"}
              toolTipTrigger={<AlertCircle className='text-red-500 w-4 h-4' />}
            />
          )}
        </div>

        <FormControl>{children}</FormControl>
        <FormMessage />
      </FormItem>
    </>
  );
};

export default FormWrapper;
